import React, { useReducer } from "react";
import DestinationsReducer from "../reducers/DestinationsReducer";
import DestinationsContext from "../DestinationsContext";
import { destinations } from "../../data/destinations";
import Cities from "../../data/cities";

const DestinationsProvider = (props) => {
  const [destinationsData, dispatch] = useReducer(DestinationsReducer, {
    destinations,
    details: {},
    cities: Cities,
    filteredCities: [],
  });
  return (
    <DestinationsContext.Provider value={{ destinationsData, dispatch }}>
      {props.children}
    </DestinationsContext.Provider>
  );
};

export default DestinationsProvider;
